import Image from '@/src/components/Image';
import { FC } from 'react';
import { Link } from '@/src/i18n/navigation';
import { useLocale, useTranslations } from 'next-intl';
import { IDigitalCard } from '@/src/types/digitalCards';
import { Routes } from '@/src/routes/routes';
import SaudiRealls from '@/src/components/sarComponent';

type Props = {
  token: string;
  data: IDigitalCard;
};

const DigitalCard: FC<Props> = ({ data, token }) => {
  const {
    arabicName,
    defaultImage,
    discount,
    englishName,
    integrationId,
    isHaveValidDiscount,
    isSoldOut,
    originalPrice,
    price,
    currencyCode,
    countryId,
    externalUrl,
    isExternalProduct,
  } = data;

  const t = useTranslations('digitalCards');
  const local = useLocale();
  const isEnglish = local === 'en';

  const stcURL = `${externalUrl}?tenant=pik&lang=${local}&token=${token}`;

  const renderUrl =
    isExternalProduct && externalUrl ? stcURL : Routes.digitalCardDetails(integrationId ?? '');

  return (
    <Link href={renderUrl}>
      <div className="w-full">
        <div className="relative aspect-1.5/1 overflow-hidden rounded-xl shadow-xs">
          <Image
            src={defaultImage}
            local
            fill
            alt={englishName}
            className="object-cover"
            sizes="(max-width: 768px) 33vw, (max-width: 1200px) 25vw, 20vw"
          />
          {isSoldOut && <div className="absolute z-20 h-full w-full bg-white/30" />}
        </div>
        <div className="flex flex-col items-start py-2">
          <h3 className="text-start text-sm font-semibold md:text-base">
            {isEnglish ? englishName : arabicName}
          </h3>

          <div className="flex items-start gap-1 text-sm lg:text-base">
            <span>{t('from')} </span>
            <SaudiRealls price={price} size="small" currency={currencyCode} countryId={countryId} />
            {isHaveValidDiscount && (
              <div className="text-primary/60 ms-1 text-xs font-bold line-through lg:text-sm">
                <SaudiRealls
                  price={Number(originalPrice?.toFixed(2))}
                  size="medium"
                  isHaveDiscount={true}
                  currency={currencyCode}
                  countryId={countryId}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </Link>
  );
};

export default DigitalCard;
